import React from "react";

function EditEvent() {
  return (
      <span className="anticon ant-edit">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
            <g fill="none" fillRule="evenodd">
                  <g fill="currentColor" opacity="0.8">
                    <g>
                        <g>
                            <g>
                                <g>
                                    <path d="M11.55 0c.524 0 1.026.21 1.392.579l2.481 2.48c.37.37.577.87.577 1.393 0 .522-.207 1.023-.577 1.393l-9.057 9.054c-.559.645-1.35 1.04-2.258 1.103H0v-.8l.003-3.372c.068-.844.46-1.628 1.058-2.155L10.156.58c.37-.371.87-.58 1.394-.58zM8.24 4.755L2.157 10.84c-.324.286-.525.687-.557 1.054v2.508l2.451.002c.428-.03.825-.23 1.145-.595l6.049-6.05-3.004-3.004zM11.55 1.6c-.097 0-.19.039-.26.108L9.373 3.624l3.004 3.004 1.916-1.915c.07-.069.108-.163.108-.26 0-.099-.039-.193-.108-.262l-2.483-2.483c-.069-.07-.162-.108-.26-.108z" transform="translate(-336 -775) translate(319 528) translate(0 228) translate(17 15) translate(0 4)"/>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>

    </span>
  );
}

export default EditEvent;
